// extracted by mini-css-extract-plugin
module.exports = {"module":"FringeBenefit_module__2oW64","content":"FringeBenefit_content__w2k7u"};